export default __webpack_public_path__ + "31fe933f3a12be1aa7f3f96ab5f0c055.svg";